import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FiUsers, FiBriefcase, FiCheckCircle } from "react-icons/fi";
import { getDashboardStats } from "../../services/adminApi";

const AdminDashboard = () => {

  const [stats, setStats] = useState({
    candidates: 0,
    castingDirectors: 0,
    projects: 0,
    roles: 0
  });

  useEffect(() => {
    getDashboardStats()
      .then(res => setStats(res.data))
      .catch(console.error);
  }, []);

  const statCards = [
    { title: "Candidates", value: stats.candidates || 0, icon: <FiUsers /> },
    { title: "Casting Directors", value: stats.castingDirectors || 0, icon: <FiUsers /> },
    { title: "Projects", value: stats.projects || 0, icon: <FiBriefcase /> },
    { title: "Roles", value: stats.roles || 0, icon: <FiCheckCircle /> }
  ];

  return (
    <div>
      {/* Page Title */}
      <h2 className="page-title">Dashboard Overview</h2>

      {/* Stats Cards */}
      <Row className="g-4">
        {statCards.map((card, index) => (
          <Col xs={12} sm={6} lg={3} key={index}>
            <Card className="stat-card h-100">
              <Card.Body className="d-flex align-items-center">
                
                {/* Icon */}
                <div className="stat-icon-wrapper">
                  {card.icon}
                </div>

                {/* Text */}
                <div className="stat-details ms-3">
                  <p>{card.title}</p>
                  <h3>{card.value}</h3>
                </div>

              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AdminDashboard;